module.exports = __webpack_public_path__ + "static/media/subscribe-mobile-close.7ca204bb.svg";